import PermissionButton from '../../permissions/PermissionButton';
import React, { useState, useEffect } from 'react';
import { Modal, Radio, Space, Button, Divider, message } from 'antd';
import { PrinterOutlined, EyeOutlined } from '@ant-design/icons';
import axios from 'axios';

const PrintDialog = ({ open, onClose, onPrint, REF_FAC }) => {
  const [printType, setPrintType] = useState('bonsortie');
  const [counters, setCounters] = useState({ facture: 0, tree: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [isFactureEnabled, setIsFactureEnabled] = useState(false);
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}`;

  // Extract the first 3 digits from REF_FAC (after the first 2 characters)
  const extractTreeDigits = (refFac) => {
    if (!refFac || refFac.length < 5) return ''; // Need at least 5 chars (2 prefix + 3 digits)
    return refFac.substring(2, 5); // Extract only 3 digits after the prefix
  };

  // Extract the first 3 digits from tree counter
  const extractFirstThreeDigits = (treeValue) => {
    const treeStr = String(treeValue);
    return treeStr.substring(0, 3);
  };

  useEffect(() => {
    if (open) {
      fetchCounters();
    }
  }, [open]);

  const fetchCounters = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${API_URL}/counter/getcountercheck`);
      setCounters(response.data);
      
      const treeDigitsFromRef = extractTreeDigits(REF_FAC);
      const treeFirstThreeDigits = extractFirstThreeDigits(response.data.tree.value);
      
      // Check if the tree digits from REF_FAC match the first 3 digits of tree counter
      setIsFactureEnabled(treeDigitsFromRef === treeFirstThreeDigits);
      
      console.log('REF_FAC tree digits:', treeDigitsFromRef);
      console.log('Tree counter first 3 digits:', treeFirstThreeDigits);
      console.log('Facture enabled:', treeDigitsFromRef === treeFirstThreeDigits);
    } catch (error) {
      console.error('Failed to fetch counters:', error);
      message.error('Failed to verify document permissions');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDirectPrint = () => {
    if (printType === 'facture' && !isFactureEnabled) {
      message.error('Facture printing is not allowed for this reference');
      return;
    }
    onPrint(printType, true); // true indicates direct print
    onClose();
  };
  
  const handlePreview = () => {
    if (printType === 'facture' && !isFactureEnabled) {
      message.error('Facture preview is not allowed for this reference');
      return;
    }
    onPrint(printType, false); // false indicates preview
    onClose();
  };
  
  return (
    <Modal
      title="Select Document Type"
      open={open}
      onCancel={onClose}
      footer={[
        <Button 
          key="preview" 
          type="default" 
          icon={<EyeOutlined />}
          onClick={handlePreview}
          loading={isLoading}
          disabled={printType === 'facture' && !isFactureEnabled}
        >
          Preview
        </Button>,
        <PermissionButton permissionModule="invoices" permissionAction="print"
          key="print" 
          type="primary" 
          icon={<PrinterOutlined />}
          onClick={handleDirectPrint}
          loading={isLoading}
          disabled={printType === 'facture' && !isFactureEnabled}
        >
          Imprimer
        </PermissionButton>
      ]}
      width={500}
    >
      <Radio.Group
        value={printType}
        onChange={(e) => setPrintType(e.target.value)}
      >
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Radio value="bonsortie">
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Bon de Sortie</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                E 1
              </div>
            </Space>
          </Radio>

          <Radio value="bonliv" disabled={!isFactureEnabled}>
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Bon de Livraison</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                E 2 {!isFactureEnabled && '(Non disponible)'}
              </div>
            </Space>
          </Radio>
          
          <Radio value="facture" disabled={!isFactureEnabled}>
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Facture</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                E 3 {!isFactureEnabled && '(Non disponible)'}
              </div>
            </Space>
          </Radio>

          <Radio value="enveloppe">
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Enveloppe</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                enveloppe client
              </div>
            </Space>
          </Radio>

          <Radio value="releve-interne">
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Relevé Interne</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                relevé interne
              </div>
            </Space>
          </Radio>

          <Radio value="releve-externe">
            <Space direction="vertical" size={0}>
              <div style={{ fontWeight: 500 }}>Relevé Externe</div>
              <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.45)' }}>
                relevé externe
              </div>
            </Space>
          </Radio>
        </Space>
      </Radio.Group>
      
      {printType === 'facture' && !isFactureEnabled && (
        <div style={{ marginTop: 16, color: '#ff4d4f' }}>
          La facture n'est pas disponible car les chiffres de la référence ne correspondent pas aux premiers chiffres du compteur tree.
        </div>
      )}
    </Modal>
  );
};

export default PrintDialog;